<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="4">
        <v-btn outlined color="secondary" to="/admin">
          Back
        </v-btn>
        <v-btn class="ml-3" @click="triggerDownload" color="primary" :loading="loading">Export </v-btn>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="3">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
          </v-card-title>
          <v-data-table :headers="headers" :items="sessions" :search="search">
              <template v-slot:[`item.createdAt`]="{ item }">
                {{ item.createdAt | formatdate }}
              </template>
              <template v-slot:[`item.chat.phoneNumber`]="{ item }">
                <router-link :to="`/session/${item.id}/messages`">{{item.chat.phoneNumber}}</router-link>
             </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Session',
  data: () => ({
    search: '',
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Phone Number', value: 'chat.phoneNumber' },
      { text: 'Created At', value: 'createdAt' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],
    loading: false
  }),
  computed: mapState({
    sessions: state => state.botsession.sessions
  }),
  created () {
    this.$store.dispatch('botsession/getSessions')
  },
  methods: {
    ...mapActions({ exportSessions: 'botsession/exportSessions' }),
    triggerDownload () {
      this.loading = true
      this.exportSessions().then(response => {
        this.loading = false
        const blob = new Blob([response.data])
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        const yourDate = new Date()
        link.download = `Session_${yourDate.toISOString().split('T')[0]}.csv`
        link.click()
      }).catch(error => {
        this.loading = false
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data.message }, { root: true })
      })
    }
  }
}
</script>
